'use strict'

module.exports = row

var all = require('../all')

function row(h, node) {
  return h(node, 'tableRow', all(h, node))
}
